"use client";

import { AuthForm } from "@/components/AuthForm";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";

function AuthPageContent() {
  const searchParams = useSearchParams();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0f0f14] p-4">
      <div className="w-full max-w-md rounded-lg border border-white/10 bg-[#121318] p-6 shadow-[0_28px_90px_rgba(0,0,0,0.55)] sm:p-8">
        <AuthForm defaultMode={searchParams?.get("mode") === "signin" ? "signin" : "signup"} />
      </div>
    </div>
  );
}

function AuthPageLoading() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0f0f14] p-4">
      <div className="w-full max-w-md rounded-lg border border-white/10 bg-[#121318] p-8 shadow-[0_28px_90px_rgba(0,0,0,0.55)]">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-orange-500 border-t-transparent" />
          <p className="text-sm text-white/55">Loading authentication...</p>
        </div>
      </div>
    </div>
  );
}

export default function AuthPage() {
  return (
    <Suspense fallback={<AuthPageLoading />}>
      <AuthPageContent />
    </Suspense>
  );
}
